import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AllItemsLoadedListDirective } from './all-items-loaded-list.directive';

@NgModule({
  declarations: [
    AllItemsLoadedListDirective
  ],
  imports: [
    CommonModule
  ],
  exports: [
    AllItemsLoadedListDirective
  ]
})
export class AllItemsLoadedListModule { }
